module.exports = __webpack_public_path__ + "media/images/site/fundamental2_desenho-19d202314803fc4895a524f43a484961.jpg";